export const verificationMethodsSelector = state =>
  state.auth.verificationMethods;

export const userVerificationMethodsSelector = state =>
  state.auth.userVerificationMethod;
